import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
import { ConfigDeviceRow } from './ConfigDeviceRow';
export const ConfigDevices = (_props) => {
    const deviceMap = useAppSelector(state => state.definitions.devices);
    const devices = Object.values(deviceMap)
        .sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
    const rows = [];
    if (devices) {
        for (const d of devices) {
            rows.push(_jsx(ConfigDeviceRow, { id: d.id }, d.id));
        }
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx("h2", { children: "Devices" }), _jsx("div", { className: "config-rows config-devices", children: rows })] }));
};
